const theme = {
  colors: {
    appBarBackground: '#24292e',
    mainBackground: '#e1e4e8',
    repoItemBackground: 'white',
    textPrimary: '#24292e',
    textSecondary: '#586069',
    textUserPrimary: '#0093e5',
    textUserSecondary: '#0066a0',
    primary: '#80C8CA',
    secondary: '#9B7872',
    primaryAlt: '#73b4b5',
    secondaryAlt: '#8b6c66',
    background: '#3D6F95',
    error: '#b70000',
    card: '#FAF9F9',
    cardAlt: '#B0A699'
  },
  height: {
    appBarHeight: 56
  },
  fontSizes: {
    body: 14,
    subHeading: 16
  },
  fontWeights: {
    fontWeightNormal: '400',
    fontWeightMedium: '500',
    fontWeightBold: '700'
  }
}

export default theme;

// appBarBackground: '#24292e',
//     mainBackground: '#e1e4e8',
//     repoItemBackground: 'white',
//     textPrimary: '#24292e',
//     textSecondary: '#586069',
//     textUserPrimary: '#0093e5',
//     textUserSecondary: '#0066a0',
//     primary: '#17293A',
//     secondary: '#E83457',
//     primaryAlt: '#2e3e4d',
//     secondaryAlt: '#ea4867',
//     background: '#E7B889',
//     error: '#b70000',
//     card: '#EEE1C5',
//     cardAlt: '#d6cab1'